import { useEffect, useRef } from 'react';

const services = [
  {
    icon: 'ri-building-2-line',
    title: 'Capital de Infraestructura',
    description: 'Financiamiento estructurado para proyectos de construcción, carreteras, puentes, plantas industriales y desarrollo urbano con plazos de hasta 8 años.',
  },
  {
    icon: 'ri-plant-line',
    title: 'Agroindustria',
    description: 'Créditos especializados para proyectos agrícolas, ganaderos, procesamiento de alimentos y cadenas de suministro agroindustriales en la región.',
  },
  {
    icon: 'ri-hotel-line',
    title: 'Hotelería y Turismo',
    description: 'Soluciones de capital para desarrollo hotelero, resorts, centros de convenciones y proyectos turísticos de alta escala en destinos estratégicos.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Logística y Puertos',
    description: 'Financiamiento para centros de distribución, terminales portuarias, flotas de transporte y redes logísticas multimodales.',
  },
  {
    icon: 'ri-home-office-line',
    title: 'Desarrollo Inmobiliario',
    description: 'Capital para proyectos residenciales, comerciales, oficinas y centros de negocios con estructuras de pago flexibles.',
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: 'Capital de Trabajo',
    description: 'Líneas de crédito ágiles para operaciones empresariales, importaciones, exportaciones y gestión de flujo de caja.',
  },
];

export default function ServicesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.service-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.classList.add('animate-fade-in-up');
                (card as HTMLElement).style.opacity = '1';
              }, i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="servicios" className="relative bg-aa-black py-16 md:py-24 overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-aa-gold/[0.02] to-transparent pointer-events-none" />

      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="mb-12 md:mb-16">
            <span className="label-tag block mb-4">NUESTROS PILARES</span>
            <h2 className="heading-display text-3xl md:text-4xl lg:text-5xl font-bold max-w-2xl">
              Solución Financiera
              <br />
              <span className="gold-text-gradient">Estructurada</span>
            </h2>
          </div>

          {/* Services Grid */}
          <div ref={sectionRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-card opacity-0 glassmorphism rounded-2xl p-6 md:p-8 gold-border-glow card-hover group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-aa-gold/10 border border-aa-gold/20 mb-5 group-hover:bg-aa-gold/20 transition-colors">
                  <i className={`${service.icon} text-aa-gold text-xl`} />
                </div>
                <h3 className="text-white font-semibold text-lg mb-3">
                  {service.title}
                </h3>
                <p className="text-aa-gray-200 text-sm leading-relaxed">
                  {service.description}
                </p>
                <div className="mt-4 flex items-center gap-2 text-aa-gold text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="whitespace-nowrap">Conocer más</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}